
import { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, HolderOutlined, UsergroupAddOutlined, CheckOutlined, EditOutlined, ClockCircleOutlined } from "@ant-design/icons"
import { Button, Checkbox, Flex, Switch, Input, Modal, Divider, Tooltip, message } from "antd"
import { deliveryUnits, teams, skillLevel1, skillLevel2, employeeLevels } from "../../../utils/resourceData.js";
import { getMasterList, getRateMaster, getSingleMasterData } from "../../../services/adminServices.js";
import { convertKeyToLabel } from "../../../utils/formsHelper.js";
import { v4 as uuidv4 } from "uuid";
import DurationBlock from "./DurationBlock.jsx";
import ResourceItem from "./ResourceItem.jsx";
import { convertDbDataToFormattedResource } from "../../../utils/masterHelper.js";
import { useTranslation } from 'react-i18next';

const Resource = (props) => {
    const { t } = useTranslation();
    const { sprintDetail, masterList, estimationData, updateEstimation } = props
    const [resources, setResources] = useState([])
    const [originalResources, setOriginalResources] = useState({})
    const [formattedResources, setFormattedResources] = useState([])
    const [openDeliveryUnitModal, setOpenDeliveryUnitModal] = useState(false)
    const [openTeamsModal, setOpenTeamsModal] = useState(false)
    const [deliveryUnitData, setDeliveryUnitData] = useState({})
    const [resourceData, setResourceData] = useState([])
    const [employeeLevelData, setEmployeeLevelData] = useState([])
    const [selectedDeliveryUnit, setSelectedDeliveryUnit] = useState({})
    const [duFields, setDuFields] = useState([])
    const [resourceFields, setResourceFields] = useState([])
    const [selectedTeam, setSelectedTeam] = useState({})
    const [selectedResource, setSelectedResource] = useState({})
    const [isTeamEdit, setIsTeamEdit] = useState(false)
    const [showTotalEffort, setShowTotalEffort] = useState(false)
    const [costViewEnable, setCostViewEnable] = useState(false)

    useEffect(() => {
        if (estimationData.resources && !estimationData.resources?.localUpdate) {
            let reqResources = estimationData.resources?.resources || []
            if (!estimationData.resources?.localUpdate) {
                reqResources = reqResources.map(resource => {
                    let curTeams = convertDbDataToFormattedResource(resource.teams)
                    let reqResourceObj = { ...resource, teams: { ...curTeams } }
                    delete reqResourceObj?.team
                    return { ...reqResourceObj }
                })
            }
            setResources(reqResources)            
            setOriginalResources(estimationData.resources)
            updateEstimation("resources", { ...originalResources, resources: reqResources, localUpdate: true })
        }
    }, [estimationData.resources])

    const getIntitialResourceData = async () => {
        let duData = await getRateMaster();
        let reqDUDate = convertKeyToLabel(duData.data)
        let rateMasterFields = masterList.find(data => data.dataName === "Rate Master")?.fields;

        let deliveryUnitDataFromList = masterList.find(data => data.dataName === "Location");
        let resourceDataFromList = masterList.find(data => data.dataName === "Resource");
        let deliveryDataFields = rateMasterFields?.filter(field => field.parentTable === deliveryUnitDataFromList.dataId)

        let reqDeliveryUnitData = reqDUDate.map(du => {
            let reqDuObj = {}
            deliveryDataFields.forEach(field => {
                reqDuObj[field.label] = du[field.label]
            })
            return { ...reqDuObj }
        })
        reqDeliveryUnitData = [...new Set(reqDeliveryUnitData)]
        setDeliveryUnitData(reqDeliveryUnitData)
        setDuFields(deliveryUnitDataFromList.fields)

        let reqResourceUnitData = reqDUDate.map(du => {
            let reqDuObj = {}
            resourceDataFromList.fields.forEach(field => {
                reqDuObj[field.label] = du[field.label]
            })
            return { ...reqDuObj }
        })
        setResourceFields(resourceDataFromList.fields)
        setResourceData(reqResourceUnitData)

        let reqEmployeeLevelData = masterList.find(list => list.dataName === "Employee Level");
        setEmployeeLevelData(reqEmployeeLevelData?.data || [])
        // setDeliveryUnitData(duData.data)

    }

    useEffect(() => {
        if (masterList?.length > 0) {
            getIntitialResourceData();

        }
    }, [masterList])

    const deliveryUnitModelTitle = (
        <Flex align="center" gap={16}>
            <Flex style={{ width: "2.5rem", height: "2.5rem", borderRadius: "50%", background: "#FFFBE6" }} align="center" justify="center">
                <UsergroupAddOutlined style={{ color: "#FAAD14" }} />
            </Flex>
            <span style={{ fontSize: "1.25rem" }}>{t('Add Delivery Unit')}</span>
        </Flex>
    )

    const deleteResource = (id) => {
        let updatedResources = resources.filter(resource => resource.uuid !== id);
        updateEstimation("resources", { ...originalResources, resources: updatedResources, localUpdate: true })

    }

    const closeDuModal = () => {
        setOpenDeliveryUnitModal(false)
    }

    const closeTeamsModal = () => {
        setOpenTeamsModal(false)
        setSelectedTeam({})
    }

    const handleAddResource = () => {
        setOpenDeliveryUnitModal(true)
    }

    const handleSelectedDeliveryUnit = (key, val) => {
        setSelectedDeliveryUnit({ ...selectedDeliveryUnit, [key]: val })
    }

    const handleDuAdd = () => {
        let reqDeliveryUnit = ""
        Object.keys(selectedDeliveryUnit).forEach(key => {
            reqDeliveryUnit += reqDeliveryUnit ? " - " + selectedDeliveryUnit[key] : selectedDeliveryUnit[key]
        })
        let updatedResources = [...resources]
        let currentRes = updatedResources.find(resource => resource.deliveryUnit === reqDeliveryUnit)
        if (currentRes) {
            message.error(t('Delivery unit already added'));
            return
        }
        let reqObj = { uuid: uuidv4(), deliveryUnit: reqDeliveryUnit, teams: {} }
        updatedResources.push(reqObj)
        updateEstimation("resources", { ...originalResources, resources: updatedResources, localUpdate: true })

        setOpenDeliveryUnitModal(false)
        setSelectedDeliveryUnit({})
    }

    const handleResourceSelection = (resourceId) => {
        setSelectedResource(resourceId)
        setOpenTeamsModal(true)
    }

    const handleSelectedResource = (key, val) => {
        let updatedSelectedTeam = { ...selectedTeam, [key]: val }
        if (key === "Team") {
            updatedSelectedTeam = { [key]: val }
        }
        setSelectedTeam({ ...updatedSelectedTeam })
    }

    const handleTeamAdd = () => {
        let durationData = {}
        for (let i = 1; i <= sprintDetail.duration; i++) {
            durationData[i] = { resourceCount: "", offShore: true, onSite: false }
        }
        let reqTeamData = { ...selectedTeam, uuid: uuidv4(), count: durationData }
        let updatedResources = resources.map(resource => {
            if (resource.uuid === selectedResource) {
                let currentTeamData = resource.team
                let reqKey = reqTeamData["Team"]

                delete reqTeamData["Team"]
                if (currentTeamData) {

                    if (currentTeamData.hasOwnProperty(reqKey)) {
                        currentTeamData[reqKey] = currentTeamData[reqKey].concat(reqTeamData)
                    } else {
                        currentTeamData[reqKey] = [reqTeamData]
                    }
                } else {
                    resource.teams = { [reqKey]: [reqTeamData] }
                }
            }
            return { ...resource }
        })
        // return
        setOpenTeamsModal(false)
        setSelectedTeam({})
        updateEstimation("resources", { ...originalResources, resources: updatedResources, localUpdate: true })
    }

    const editTeam = (resourceId, teamName, teamId) => {
        let reqResource = resources.find(resource => resource.uuid === resourceId);
        let reqTeam = { "Team": teamName }
        let reqTeamData = reqResource["teams"][teamName].find(team => team.uuid === teamId);
        setSelectedTeam({ ...reqTeam, ...reqTeamData })
        setSelectedDeliveryUnit(reqResource)
        setOpenTeamsModal(true)
        setIsTeamEdit(true)
        // let updatedResources = resources.map(resource => {
        //     if(resource.id === resourceId){
        //         let currentTeamData = resource.team[teamName]
        //         currentTeamData = currentTeamData.filter(team => team.uuid === teamId)
        //         resource.team[teamName] = currentTeamData
        //     }
        //     return {...resource}
        // })
        // setResources(updatedResources)
    }

    const removeTeam = (key, teamIndex, resourceId) => {
        // return
        let updatedResources = resources.map(resource => {
            if (resource.uuid === resourceId) {
                resource.team = resource.team[key].filter((teamData, index) => index !== teamIndex)
            }
            return { ...resource }
        })
        updateEstimation("resources", { ...originalResources, resources: updatedResources, localUpdate: true })

    }

    const handleCountChange = (teamId, teamName, resourceId, key, value, countKey) => {
        let updatedResources = resources.map(resource => {
            if (resource.uuid === resourceId) {
                resource.team[teamName] = resource.teams[teamName].map((teamData, index) => {
                    if (teamId === teamData.uuid) {
                        let reqTeamData = {}
                        if (countKey === "onsite") {
                            reqTeamData = { ...teamData, count: { ...teamData.count, [key]: { ...teamData.count[key], onSite: value, offShore: !value } } }
                        } else {
                            reqTeamData = { ...teamData, count: { ...teamData.count, [key]: { ...teamData.count[key], [countKey]: Number(value) } } }
                        }
                        return { ...reqTeamData }
                    } else {
                        return { ...teamData }
                    }
                })
            }
            return { ...resource }
        })
        updateEstimation("resources", { ...originalResources, resources: updatedResources, localUpdate: true })

    }

    const handleEnableCost = (checked) => {
        setCostViewEnable(checked)
    }

    return (
        <>
            <Flex justify="space-between" align="center" style={{ padding: "0.75rem 2.5rem" }}>
                <div className="text-" style={{ color: "#000" }}>{t('Resources')}</div>
                <Checkbox checked={showTotalEffort} onChange={(e) => setShowTotalEffort(e.target.checked)}>{t('Show Total Effort')}</Checkbox>
            </Flex>
            <div className="sprint-container" style={{ minHeight: resources?.length === 0 ? "23rem" : "fit-content" }}>
                <div className="sprint-header-row">
                    <div className="sprint-left-section">
                        <div className="add-sprint" style={{ justifyContent: "space-between", padding: "0 1rem 0 2.5rem" }}>
                            <span><Button className="submit-button" size="small" icon={<PlusOutlined />} style={{ marginRight: "8px" }} onClick={handleAddResource} />{t('Add Resource')}</span>
                            <span>{t('Cost View')} <Switch size="small" checked={costViewEnable} onChange={handleEnableCost} /></span>

                        </div>

                    </div>

                    <div className="sprint-right-section">
                        <div className="empty-block">{sprintDetail.timeline} </div>
                        <Flex>
                            {
                                [...Array(sprintDetail.duration)].map((e, i) => {
                                    return <div className="week-block" key={i} >
                                        <div className="week-cell" style={{ borderLeft: i === 0 ? "0px solid" : "1px solid #C7C8F3" }}>
                                            {Number(i + 1)}
                                        </div>
                                    </div>
                                })
                            }
                            <div className="week-block" style={{ flexGrow: "1", maxWidth: "none" }}>
                                <div className="week-cell" style={{ justifyContent: "flex-start", paddingLeft: "1rem", borderLeft: "1px solid #C7C8F3" }}>
                                </div>
                            </div>
                        </Flex>
                    </div>
                </div>

                {
                    resources?.length > 0 && resources.map((resource, index) => {
                        return (
                            <ResourceItem resource={resource} handleResourceSelection={handleResourceSelection} deleteResource={deleteResource} sprintDetail={sprintDetail} removeTeam={removeTeam} editTeam={editTeam} handleCountChange={handleCountChange} costViewEnable={costViewEnable} />
                        )
                    })
                }
                {
                    showTotalEffort ?
                        <div className="total-effort-row">
                            <div className="left-section-row-data">
                                <span style={{ color: "#141BCB", marginLeft: "3rem" }}><ClockCircleOutlined style={{ marginRight: "8px" }} /> {t('Total Effort')}</span>

                            </div>
                            <Flex align="center">
                                {
                                    [...Array(sprintDetail.duration)].map((e, i) => {
                                        let totalCosts = costViewEnable ? originalResources.totalCostPerPeriod || {} : originalResources.totalTimelineEffort || {}
                                        return <div className="week-block" key={i} >
                                            <div className="effort-cell" style={{ textAlign: "center", color: "#000" }}>{totalCosts[i + 1] || ""}</div>
                                        </div>
                                    })
                                }
                                <div className="week-block">
                                    <div className="effort-cell" style={{ textAlign: "center", color: "#000", background: "#D3ADF7" }}>{costViewEnable ? originalResources.totalTeamCost || "" : originalResources.totalEffort || ""}</div>
                                </div>
                            </Flex>
                        </div>
                        : null
                }
            </div>

            <Modal open={openDeliveryUnitModal} title={deliveryUnitModelTitle} onOk={closeDuModal} onCancel={closeDuModal} footer={false} className="add-resource-modal">
                <Divider className="modal-divider" />
                <Flex justify="space-between" gap={16} style={{ minHeight: "300px" }}>
                    {
                        duFields?.map((field, index) => {
                            let fieldValue = [...new Map(deliveryUnitData.map(item =>
                                [item[field.label], item])).values()];
                            if (index !== 0) {
                                let prevField = duFields[index - 1];
                                if (selectedDeliveryUnit[prevField.label]) {
                                    fieldValue = fieldValue.filter(value => value[prevField.label] === selectedDeliveryUnit[prevField.label])
                                }
                            }

                            return (
                                <div className="unit-block">
                                    <div className="text-color-secondary field-value">{field.label}</div>
                                    {
                                        fieldValue.map(itemData => {
                                            return <div className={`${selectedDeliveryUnit[field.label] === itemData[field.label] ? 'selected-unit' : ''} unit-value field-value`} onClick={() => handleSelectedDeliveryUnit(field.label, itemData[field.label])}>
                                                {itemData[field.label]} <span><CheckOutlined /></span>
                                            </div>
                                        })
                                    }
                                </div>

                            )
                        })
                    }
                </Flex>
                <Divider className="modal-divider-bottom" />
                <Flex gap={16} justify="flex-end">
                    <Button className="submit-button" onClick={handleDuAdd}>{t('Add')}</Button>
                    <Button onClick={closeDuModal}>{t('Cancel')}</Button>
                </Flex>
            </Modal>

            <Modal open={openTeamsModal} title={"Add Teams"} onOk={closeTeamsModal} onCancel={closeTeamsModal} footer={false} className="add-resource-modal">
                <Divider className="modal-divider" />
                <Flex justify="space-between" gap={16} style={{ minHeight: "300px" }}>
                    {
                        resourceFields?.map((field, index) => {
                            let fieldValue = [...new Map(resourceData.map(item =>
                                [item[field.label], item])).values()];
                            fieldValue = fieldValue?.filter(val => val[field.label])
                            if (index !== 0) {
                                let prevField = resourceFields[index - 1];
                                if (selectedTeam[prevField.label]) {
                                    fieldValue = fieldValue.filter(value => value[prevField.label] === selectedTeam[prevField.label])
                                }
                            }

                            return (
                                <div className="unit-block">
                                    <div className="text-color-secondary field-value">{field.label}</div>
                                    {
                                        fieldValue.map(itemData => {
                                            return <div className={`${selectedTeam[field.label] === itemData[field.label] ? 'selected-unit' : ''} unit-value field-value`} onClick={() => handleSelectedResource(field.label, itemData[field.label])}>
                                                {itemData[field.label]} <span><CheckOutlined /></span>
                                            </div>
                                        })
                                    }
                                </div>

                            )
                        })
                    }
                    {
                        employeeLevelData.length > 0 &&
                        <div className="unit-block">
                            <div className="text-color-secondary field-value">{t('Employee Level')}</div>

                            {
                                employeeLevelData.map(data => {
                                    return <div className={`${selectedTeam["Employee Level"] === data["Employee Level"] ? 'selected-unit' : ''} unit-value field-value`} onClick={() => handleSelectedResource("Employee Level", data["Employee Level"])}>
                                        {data["Employee Level"]} <span><CheckOutlined /></span>
                                    </div>
                                })
                            }
                        </div>
                    }
                </Flex>
                <Divider className="modal-divider-bottom" />
                <Flex gap={16} justify="flex-end">
                    <Button className="submit-button" onClick={handleTeamAdd}>{isTeamEdit ? "Update" : "Add"} </Button>
                    <Button onClick={closeTeamsModal}>{t('Cancel')}</Button>
                </Flex>
            </Modal>
        </>
    )
}

export default Resource